import React from "react";
import styled from "styled-components";
import { Skeleton } from "components/ui/Skeleton";
import { Card, CardContent, CardHeader, CardTitle } from "components/ui/Card";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "components/ui/Table";

const StyledCard = styled(Card)`
  box-shadow: none;
  padding: 0 16px;
  gap: 0;
  border: none;
`;

const StyledCardHeader = styled(CardHeader)`
  width: 100%;
  display: flex;
  align-items: center;
  margin-bottom: 12px;
  padding: 0;
`;

const StyledCardTitle = styled(CardTitle)`
  font-size: 1rem;
  font-weight: 700;
  line-height: 24px;
  letter-spacing: -0.2px;
`;

const StyledCardContent = styled(CardContent)`
  padding: 0;
`;

const OverflowWrapper = styled.div`
  overflow-x: auto;
`;

const SkeletonFullWidth = styled(Skeleton)`
  height: 20px;
  width: 100%;
`;

export const MembersDataTableSkeleton = ({
  periodText,
}: {
  periodText: string;
}) => {
  return (
    <StyledCard>
      <StyledCardHeader>
        <StyledCardTitle>{periodText}</StyledCardTitle>
      </StyledCardHeader>
      <StyledCardContent>
        <OverflowWrapper>
          <Table>
            <TableHeader>
              <TableRow>
                {[...Array(7)].map((_, i) => (
                  <TableHead key={i}>
                    <SkeletonFullWidth />
                  </TableHead>
                ))}
              </TableRow>
            </TableHeader>
            <TableBody>
              {[...Array(5)].map((_, rowIndex) => (
                <TableRow key={rowIndex}>
                  {[...Array(7)].map((_, cellIndex) => (
                    <TableCell key={cellIndex}>
                      <SkeletonFullWidth />
                    </TableCell>
                  ))}
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </OverflowWrapper>
      </StyledCardContent>
    </StyledCard>
  );
};
